import './App.css';
import React, { useEffect, useState } from 'react';
import AppRoutes from './Routes';
import {Helmet} from "react-helmet";

// function App() {
//   return <AppRoutes initialRoute={initialRoute} />;
// }

// export default App;

function App() {
  return (
    <div>
      <Helmet>
      <meta charSet="utf-8" />
        <meta name='keywords' content=''/>
        <meta name='description' content=''/>
      </Helmet>
      <AppRoutes />
    </div>
  );
}
export default App;

